export const IT = "it";
export const EN = "en";
